import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { Config } from "./config.interface";

@Injectable({ providedIn: 'root' })
export class ConfigService {
    private _config: Config | null = null;

    constructor(private readonly _httpClient: HttpClient) { }

    public async getConfig(): Promise<Config> {
        if (this._config)
            return this._config;

        this._config = await firstValueFrom(this._httpClient.get<Config>('assets/config.json'));
        return this._config;
    }


    public get config() {
        return this._config;
    }

    public get(key: string): any {
        if (!this._config)
            throw new Error('Config has not been loaded yet!');

        return this._config[key];
    }
}
